/** Central query keys for React Query. */
export const queryKeys = {
  knowledgebase: (product) => ["knowledgebase", product].filter(Boolean),
  availableFeatures: (product) => ["availableFeatures", product].filter(Boolean),
  articleSearchSuggestions: (searchTerm, product) =>
    ["articleSearch", searchTerm, product].filter(Boolean),
  keywordResults: (query, product) =>
    ["keywordResults", query, product].filter(Boolean),
  categories: (product) => ["categories", product].filter(Boolean),
  allCategories: (product) => ["allCategories", product].filter(Boolean),
  categoryBySlug: (slug, product) =>
    ["categoryBySlug", slug, product].filter(Boolean),
  subCategories: (categorySlug, product) =>
    ["subCategories", categorySlug, product].filter(Boolean),
  categoryBySlugs: (slugs, product) =>
    ["categoryBySlugs", slugs, product].filter(Boolean),
  categoryArticles: (categorySlug, product) =>
    ["categoryArticles", categorySlug, product].filter(Boolean),
  article: (articleSlug, product) =>
    ["article", articleSlug, product].filter(Boolean),
};
